import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="text-center py-8 px-4 bg-background border-t border-primary/5 text-text-secondary text-sm">
      <div className="flex justify-center gap-6 mb-4 flex-wrap">
        <Link to="/" className="hover:text-gold transition">Inicio</Link>
        <Link to="/productos" className="hover:text-gold transition">Productos</Link>
        <Link to="/login" className="hover:text-gold transition">Iniciar sesión</Link>
      </div>
      <p>Hecho con <strong className="text-gold">❤️</strong> y <strong className="text-gold">🥖</strong> · Tupastel © 2026</p>
    </footer>
  );
};

export default Footer;
